"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPortalData = setPortalData;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

function setPortalData(portal) {
  return {
    type: _ActionTypes.SET_PORTAL,
    payload: portal
  };
}